import { render } from "./AkLayout.vue?vue&type=template&id=4e2c2442"
import script from "./AkLayout.vue?vue&type=script&lang=js"
export * from "./AkLayout.vue?vue&type=script&lang=js"

import exportComponent from "/root/dirif/preprod/dirif-fo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__